/* =============================================
   Japlish Wishlist + 閲覧履歴
   localStorage ベース
   商品タイトル横ハート対応
   ============================================= */

(function () {
  'use strict';

  var WISHLIST_KEY = 'japlish_wishlist';
  var VIEWED_KEY = 'japlish_recently_viewed';
  var VIEWED_MAX = 8;

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function getViewed() {
    try {
      return JSON.parse(localStorage.getItem(VIEWED_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveViewed(list) {
    localStorage.setItem(VIEWED_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().some(function (item) {
      return item.handle === handle;
    });
  }

  function toggleWishlist(product) {
    var list = getWishlist();

    var index = list.findIndex(function (item) {
      return item.handle === product.handle;
    });

    if (index === -1) {
      list.push(product);
      saveWishlist(list);
      return true;
    }

    list.splice(index, 1);
    saveWishlist(list);
    return false;
  }

  function updateButtonState(button, active) {
    if (!button) return;

    var icon = button.querySelector(
      '.japlish-wishlist-title-btn__icon'
    );

    if (active) {
      button.classList.add('is-active');

      if (icon) {
        icon.setAttribute('fill', 'currentColor');
      }

      button.setAttribute(
        'aria-label',
        'お気に入りから削除'
      );
    } else {
      button.classList.remove('is-active');

      if (icon) {
        icon.setAttribute('fill', 'none');
      }

      button.setAttribute(
        'aria-label',
        'お気に入りに追加'
      );
    }
  }

  function updateProductWishlistButton(handle) {
    document
      .querySelectorAll('.japlish-wishlist-title-btn')
      .forEach(function (button) {

        if (button.dataset.handle === handle) {
          updateButtonState(
            button,
            isInWishlist(handle)
          );
        }

      });
  }

  function updateHeaderBadge() {
    document
      .querySelectorAll('.japlish-wishlist-header-link')
      .forEach(function (link) {

        if (getWishlist().length > 0) {
          link.classList.add('has-items');
        } else {
          link.classList.remove('has-items');
        }

      });
  }

  function handleWishlist(button) {

    var handle = button.dataset.handle;

    if (!handle) return;

    var product = {
      handle: handle,
      title: button.dataset.title || '',
      url: button.dataset.url || '',
      image: button.dataset.image || '',
      price: button.dataset.price || '',
      priceText: button.dataset.priceText || ''
    };

    var added = toggleWishlist(product);

    updateProductWishlistButton(handle);
    updateHeaderBadge();

    button.setAttribute(
      'data-wishlist-state',
      added ? 'added' : 'removed'
    );
  }

  function initWishlist() {

    document
      .querySelectorAll('.japlish-wishlist-title-btn')
      .forEach(function (button) {

        updateButtonState(
          button,
          isInWishlist(button.dataset.handle)
        );

      });

  }

  function recordViewed(product) {

    var list = getViewed().filter(function (item) {
      return item.handle !== product.handle;
    });

    list.unshift(product);

    if (list.length > VIEWED_MAX) {
      list = list.slice(0, VIEWED_MAX);
    }

    saveViewed(list);
  }

  function recordCurrentProduct() {

    var button = document.querySelector(
      '.japlish-wishlist-title-btn'
    );

    if (!button) return;

    recordViewed({
      handle: button.dataset.handle || '',
      title: button.dataset.title || '',
      url: button.dataset.url || '',
      image: button.dataset.image || '',
      price: button.dataset.price || '',
      priceText: button.dataset.priceText || ''
    });

  }

  function renderWishlistPage() {

    var container = document.querySelector(
      '.japlish-wishlist-page'
    );

    if (!container) return;

    var list = getWishlist();

    if (!list.length) {

      container.innerHTML =
        '<p class="japlish-empty-msg">' +
        'お気に入りに追加された商品はありません。<br>' +
        '<small>' +
        '※このお気に入りリストはこのブラウザにのみ保存されます。<br>' +
        '別の端末やブラウザからは表示されません。' +
        '</small>' +
        '</p>';

      return;
    }

    var html =
      '<div class="japlish-product-grid">';

    list.forEach(function (item) {

      html +=
        '<div class="japlish-product-card">' +
          '<a href="' + item.url + '" class="japlish-product-card__image-wrap">' +
            '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
          '</a>' +

          '<div class="japlish-product-card__info">' +
            '<a href="' + item.url + '" class="japlish-product-card__title">' +
              item.title +
            '</a>' +

            '<p class="japlish-product-card__price">' +
              item.priceText +
            '</p>' +
          '</div>' +

          '<button class="japlish-remove-btn" data-handle="' +
            item.handle +
            '" aria-label="削除">' +
            '✕ お気に入りから削除' +
          '</button>' +

        '</div>';

    });

    html += '</div>';

    container.innerHTML = html;

    container
      .querySelectorAll('.japlish-remove-btn')
      .forEach(function (button) {

        button.addEventListener('click', function () {

          var list = getWishlist().filter(function (item) {
            return item.handle !== button.dataset.handle;
          });

          saveWishlist(list);

          renderWishlistPage();
          updateHeaderBadge();

        });

      });

  }

  function renderRecentlyViewed() {

    var containers = document.querySelectorAll(
      '.japlish-recently-viewed'
    );

    if (!containers.length) return;

    var currentButton = document.querySelector(
      '.japlish-wishlist-title-btn'
    );

    var currentHandle = currentButton
      ? currentButton.dataset.handle
      : null;

    var list = getViewed().filter(function (item) {
      return item.handle !== currentHandle;
    });

    containers.forEach(function (container) {

      if (!list.length) {
        container.style.display = 'none';
        return;
      }

      container.style.display = '';

      var html =
        '<h2 class="japlish-section-title">最近見た商品</h2>' +
        '<div class="japlish-product-grid">';

      list.forEach(function (item) {

        html +=
          '<div class="japlish-product-card">' +

            '<a href="' + item.url + '" class="japlish-product-card__image-wrap">' +
              '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
            '</a>' +

            '<div class="japlish-product-card__info">' +
              '<a href="' + item.url + '" class="japlish-product-card__title">' +
                item.title +
              '</a>' +

              '<p class="japlish-product-card__price">' +
                item.priceText +
              '</p>' +
            '</div>' +

          '</div>';

      });

      html += '</div>';

      container.innerHTML = html;

    });

  }

  /*
   * ここが今回の重要部分。
   * capture=true でクリックを先に捕まえる。
   * 親要素側でイベントを止められていても処理する。
   */

  document.addEventListener(
    'click',
    function (event) {

      var button = event.target.closest(
        '.japlish-wishlist-title-btn'
      );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      handleWishlist(button);

    },
    true
  );


  document.addEventListener(
  'DOMContentLoaded',
  function () {

    initWishlist();
    updateHeaderBadge();
    recordCurrentProduct();
    renderWishlistPage();
    renderRecentlyViewed();
  }
);

})();